export const TEXT_PRINT_COLOR = "blue";
export const TEXT_PRINT_FONT_WEIGHT = 600;
